module.exports = __webpack_public_path__ + "img/112.41c08243.png";